import styled from 'styled-components';
import { th } from 'style/theme';

export const ErrorMessage = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-start;
  font-size: 14px;
  color: ${th('colors.fuzzyWuzzyBrown')};
  > :first-child {
    flex-shrink: 0;
  }
  a,
  a:hover {
    color: inherit;
  }
`;
